import { WarningIcon } from '@chakra-ui/icons'
import { Alert, Button } from '@chakra-ui/react'
import { Link } from 'react-router-dom'


export const OfferInvalidMessage = ({ url }: { url: string }) => {
    return (
        <Alert colorScheme='orange' gap={2}>
            <WarningIcon />
            Vybraná nabídka již není platná. Prosím vraťte se zpět na srovnání nabídek pro přepočítání.
            <Button
                ml={8}
                as={Link}
                to={url}
                colorScheme='orange'
            >
                Zpět
            </Button>
        </Alert>
    )
}